// Pending non-store server writes (profile / language) that should survive a
// page-hide/refresh on iOS. Scoped docs already flush via the App.js write-through
// beacon; these go through PATCH /api/auth/me, so we mirror them here and re-send via
// navigator.sendBeacon (POST → /api/auth/me) on unload — the reliable iOS transport.
// Entries are keyed (latest value wins) and cleared once the normal request confirms.
const API = process.env.REACT_APP_API_URL || '';
const _q = new Map(); // id -> { path, body }

export const beaconQueue = {
  set(id, path, body) { _q.set(id, { path, body }); },
  clear(id) { _q.delete(id); },
  flush() {
    if (typeof navigator === 'undefined' || !navigator.sendBeacon || _q.size === 0) return;
    for (const { path, body } of _q.values()) {
      try {
        navigator.sendBeacon(`${API}${path}`, new Blob([JSON.stringify(body)], { type: 'application/json' }));
      } catch { /* ignore */ }
    }
  },
};
